import { useDeleteOrganisationMutation } from "@sso/apis/organisations";
import { useGetOrganisationById } from "@sso/apis/organisations/hooks";
import { DialogTitle } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { Typography } from "@sso/ui/Typography";

import { DialogActionButtons, DialogBody, DialogHeader } from "../components";

export const DeleteOrganisationDialog = () => {
  const { id } = useAppSelector(selectDialog);
  const org = useGetOrganisationById(id as number);

  const [deleteOrganisation, { isLoading }] = useDeleteOrganisationMutation();

  const handleDeleteAction = () => {
    if (!id || !org) {
      return;
    }
    deleteOrganisation(id as number);
  };

  return (
    <>
      <DialogHeader title={DialogTitle.DELETE_ORGANISATION} />
      <DialogBody>
        <Typography display="initial">
          Are you sure to delete this Organisation?
          <br />
          <br />
          <small>{org ? `Name: ${org.name}` : "Error finding the organisation"}</small>
        </Typography>
      </DialogBody>
      <DialogActionButtons loading={isLoading} buttonTitle={"Delete"} onClickAction={handleDeleteAction} />
    </>
  );
};
